import React, { useContext } from 'react';
import {
	CreateSubCategoryContext,
	ICreateSubCategoryContext,
} from '../../../../createSubCategoryState/createSubCategoryContext';
import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './CreationForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '18:13',
		optimalResolutions: {
			a: '324*234px',
			b: '648*468px',
		},
	},
	vertical: {
		ratio: '25:13',
		optimalResolutions: {
			a: '500*260px',
			b: '1000*520px',
		},
	},
};

interface IProps {
	isVisible: boolean;
}

const CreationForm: React.FC<IProps> = ({ isVisible }) => {
	const { setFileId, fileId } = useContext<ICreateSubCategoryContext>(CreateSubCategoryContext);
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={containerClasses} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				setFileId={setFileId}
				deletePhotoHandler={deletePhotoHandler}
				horizontalAspectRatio={324 / 234}
				verticalAspectRatio={500 / 260}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};

export default CreationForm;
